export enum MenuGroups {
  Edit = 'edit',
  Lifecycle = 'lifecycle',
}

export enum SubMenu {
  // Placeholder for future submenus
  None = 'none',
}
